import React from 'react'
import style from './style.module.less'

export default props => {
  const { item, children, nextIsMenuItem } = props
  return (
    <>
      <div className={style['menu-item-group']}>
        <div className={style['menu-item-group-title']}>{item.title}</div>

        {children}
      </div>

      {nextIsMenuItem && <div className={style['menu-item-group-seperate']} />}
    </>
  )
}
